export default __webpack_public_path__ + "static/media/1-tablet-popup-image-promo-app.bc4e4949.png";